import { REPORT_CHART_ADAPTER } from '../report-builder/chart-adapter'

// Ask charts are report charts on the conversation's private workspace, read-only in the chat. No
// report_id is sent with their data requests: the server then resolves the chart's own workspace and
// authorizes the asker against it, which is the only report an Ask chart may render under.
export const ASK_CHART_ADAPTER = {
  ...REPORT_CHART_ADAPTER,
  dataRequestParams: () => ({}),
  // The report drill-down (GET /transactions?report_chart_id=) authorizes through ReportPolicy and
  // scopes by report municipality + section, neither of which fits a private Ask workspace.
  drillDownParams: null
}
